<template>
  <div>
    <div class="container">
      <div class="row">
        <div class="col-12 mx-auto   mb-4 mb-lg-5">
          <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mx-auto">
            <div
              class="form--v10 px-3 py-4 px-md-5 py-md-6 rounded--11 bg-color--light--1"
            >
              <div class="container">
                <h3 class="text-center pb-4">جزییات قرارداد</h3>
                <!-- ====== supplier_name &  net_amount ===========-->
                <div class="row justify-content-between">
                  <!--   supplier_name   -->
                  <div class="col-md-5">
                    <div>
                      <label class="form__label font-size--15 font-w--500">{{
                        $t("contract.supplier_name") + "  :  "
                      }}</label>
                      <label
                        class="form__label text-uppercase font-size--15 font-w--400"
                        >{{ "  " + supplier_name }}</label
                      >
                    </div>
                  </div>
                  <!--   net_amount   -->
                  <div class="col-md-6">
                    <div class="form-group">
                      <label class="form__label font-size--15 font-w--500">{{
                        $t("contract.net_amount") + "  :  "
                      }}</label>
                      <vue-numeric
                        id="net_amount"
                        separator=","
                        v-model="net_amount"
                        class="form-control"
                        read-only
                      ></vue-numeric>
                      <label class="form__label font-size--15 font-w--400"
                        >{{ "&nbsp;" + $t("contract.rial") }} &nbsp;</label
                      >
                    </div>
                  </div>
                </div>

                <!-- ====== downpayment &  number_of_instalment ===========-->
                <div class="row justify-content-between">
                  <!--   downpayment   -->
                  <div class="col-md-5">
                    <div>
                      <label class="form__label font-size--15 font-w--500">{{
                        $t("contract.downpayment") + "  :  "
                      }}</label>
                      <vue-numeric
                        id="downpayment"
                        separator=","
                        v-model="downpayment"
                        class="form-control"
                        read-only
                      ></vue-numeric>
                      <label class="form__label font-size--15 font-w--400"
                        >{{ "&nbsp;" + $t("contract.rial") }} &nbsp;</label
                      >
                    </div>
                  </div>
                  <!--   number_of_instalment   -->
                  <div class="col-md-6">
                    <div class="form-group">
                      <label class="form__label font-size--15 font-w--500"
                        >{{
                          $t("contract.number_of_instalment")
                        }}
                        &nbsp;:&nbsp;</label
                      >
                      <label
                        class="form__label text-uppercase font-size--15 font-w--400"
                        >&nbsp;{{ number_of_instalment }}&nbsp;</label
                      >
                      <label
                        class="form__label text-uppercase font-size--15 font-w--400"
                        >&nbsp; ماه &nbsp;</label
                      >
                    </div>
                  </div>
                </div>

                <!-- ====== instalment_amount &  total_amount_of_instalments ===========-->
                <div class="row justify-content-between">
                  <!--   instalment_amount   -->
                  <div class="col-md-5">
                    <div>
                      <label class="form__label font-size--15 font-w--500">{{
                        $t("contract.instalment_amount") + "  :  "
                      }}</label>
                      <vue-numeric
                        id="instalment_amount"
                        separator=","
                        v-model="instalment_amount"
                        class="form-control"
                        read-only
                      ></vue-numeric>
                      <label class="form__label font-size--15 font-w--400"
                        >{{ "&nbsp;" + $t("contract.rial") }} &nbsp;</label
                      >
                    </div>
                  </div>
                  <!--   total_amount_of_instalments   -->
                  <div class="col-md-6">
                    <div class="form-group">
                      <label class="form__label font-size--15 font-w--500"
                        >{{
                          $t("contract.total_amount_of_instalments")
                        }}
                        &nbsp;:&nbsp;</label
                      >
                      <vue-numeric
                        id="total_amount_of_instalments"
                        separator=","
                        v-model="total_amount_of_instalments"
                        class="form-control"
                        read-only
                      ></vue-numeric>
                      <label class="form__label font-size--15 font-w--400"
                        >{{ "&nbsp;" + $t("contract.rial") }} &nbsp;</label
                      >
                    </div>
                  </div>
                </div>

                <!-- ====== number_of_pays &  remaining_amount ===========-->
                <div class="row justify-content-between">
                  <!--    instalment_start_date   -->
                  <div class="col-md-6">
                    <div>
                      <label
                        class="form__label text-uppercase font-size--15 font-w--500"
                        >{{
                          $t("contract.instalment_start_date")
                        }}
                        &nbsp;&nbsp;:&nbsp;&nbsp;&nbsp;</label
                      >
                      <label
                        class="form__label text-uppercase font-size--15 font-w--400"
                      >
                        &nbsp;&nbsp;
                        {{ instalment_start_date | moment("jYYYY/jMM/jD ") }}
                      </label>
                    </div>
                  </div>
                  <!--   number_of_pays   -->
                  <div class="col-md-6">
                    <div class="form-group">
                      <label class="form__label font-size--15 font-w--500"
                        >{{
                          $t("contract.number_of_pays")
                        }}
                        &nbsp;:&nbsp;</label
                      >
                      <label
                        class="form__label text-uppercase font-size--15 font-w--400"
                        >&nbsp;{{ number_of_pays }}&nbsp;</label
                      >
                      <label
                        class="form__label text-uppercase font-size--15 font-w--400"
                        >&nbsp; ماه &nbsp;</label
                      >
                    </div>
                  </div>
                </div>

                <!-- ====== debit_amount &  total_amount_of_instalments ===========-->
                <div class="row justify-content-between ">
                  <!--   debit_amount   -->
                  <div class="col-md-6">
                    <div>
                      <label class="form__label font-size--15 font-w--500">{{
                        $t("contract.debit_amount") + "  :  "
                      }}</label>
                      <vue-numeric
                        id="debit_amount"
                        separator=","
                        v-model="debit_amount"
                        class="form-control"
                        read-only
                      ></vue-numeric>
                      <label class="form__label font-size--15 font-w--400"
                        >{{ "&nbsp;" + $t("contract.rial") }} &nbsp;</label
                      >
                    </div>
                  </div>
                  <!--   remaining_amount   -->
                  <div class="col-md-6">
                    <div>
                      <label class="form__label font-size--15 font-w--500">{{
                        $t("contract.remaining_amount") + "  :  "
                      }}</label>
                      <vue-numeric
                        id="remaining_amount"
                        separator=","
                        v-model="remaining_amount"
                        class="form-control"
                        read-only
                      ></vue-numeric>
                      <label class="form__label font-size--15 font-w--400"
                        >{{ "&nbsp;" + $t("contract.rial") }} &nbsp;</label
                      >
                    </div>
                  </div>
                </div>

                <!-- ========== sign_date & end_date ===============-->
                <br>
                <div class="row justify-content-between">
                  <!--   sign_date   -->
                  <div class="col-md-6">
                    <div>
                      <label
                        class="form__label text-uppercase font-size--15 font-w--500"
                        >{{
                          $t("contract.sign_date")
                        }}
                        &nbsp;&nbsp;:&nbsp;&nbsp;&nbsp;</label
                      >
                      <label
                        class="form__label text-uppercase font-size--15 font-w--400"
                      >
                        &nbsp;&nbsp; {{ sign_date | moment("jYYYY/jMM/jD ") }}
                      </label>
                    </div>
                  </div>

                  <!--   end_date   -->
                  <div class="col-md-6">
                    <div>
                      <label
                        class="form__label text-uppercase font-size--15 font-w--500"
                        >{{
                          $t("contract.end_date")
                        }}
                        &nbsp;&nbsp;:&nbsp;&nbsp;&nbsp;</label
                      >
                      <label
                        class="form__label text-uppercase font-size--15 font-w--400"
                      >
                        &nbsp;&nbsp; {{ end_date | moment("jYYYY/jMM/jD ") }}
                      </label>
                    </div>
                  </div>
                </div>

                <!-- ========== description & status ===============-->
                <br>
                <div class="row justify-content-between">
                  <!--   description   -->
                  <div class="col-md-6">
                    <div>
                      <label
                        class="form__label text-uppercase font-size--15 font-w--500"
                        >{{
                          $t("contract.description")
                        }}
                        &nbsp;&nbsp;:&nbsp;&nbsp;&nbsp;</label
                      >
                      <label
                        class="form__label text-uppercase font-size--15 font-w--400"
                      >
                        {{ description }}
                      </label>
                    </div>
                  </div>

                  <!--   status   -->
                  <div class="col-md-6">
                    <div>
                      <label
                        class="form__label text-uppercase font-size--15 font-w--500"
                        >{{
                          $t("contract.status")
                        }}
                        &nbsp;&nbsp;:&nbsp;&nbsp;&nbsp;</label
                      >
                      <label
                        class="form__label text-uppercase font-size--15 font-w--400"
                      >
                        <span v-html="statusShow(status)"> </span>
                      </label>
                    </div>
                  </div>
                </div>

                <!-- ========== vcc_number  ===============-->
                <br>
                <div class="row justify-content-between">
                  <!--   vcc_number   -->
                  <div class="col-md-6">
                    <div>
                      <label
                        class="form__label text-uppercase font-size--15 font-w--500"
                        >{{
                          $t("contract.vcc_number")
                        }}
                        &nbsp;&nbsp;:&nbsp;&nbsp;&nbsp;</label
                      >
                      <label
                        class="form__label text-uppercase font-size--15 font-w--400"
                      >
                        {{ vcc_number }}
                      </label>
                    </div>
                  </div>
                </div>
              </div>

                <!-- <h4 class="text-center mt-5">{{$t("contract.instalment-table")}}</h4>
              <vue-good-table
                :columns="columns"
                :rows="rows"
                :line-numbers="true"
                :rtl="true"
                :row-style-class="rowStyleClassFn"
                class="mt-3  pb-10 mr-0 ml-0 px-2 pt-1"
              >
                <template slot="table-row" slot-scope="props">
                  <span v-if="props.column.field == 'status'">
                    <span v-html="statusFn(props.row.status)"> </span>
                  </span>
                  <span v-else-if="props.column.field == 'date'">
                    {{ props.row.date | moment("jYYYY/jMM/jD ") }}</span
                  >

                  <span v-else>
                    {{ props.formattedRow[props.column.field] }}
                  </span>
                </template>
              </vue-good-table> -->
              <br>
              <hr>
              <div class="row justify-content-between">
							<!-- <template #start> -->
							<router-link
								:to = "
									'/customer/instalments/' + this.id
								"
								class="btn btn-bg--dark btn-size--sm btn-hover--3d col-md-5 col-sm-10"
								replace
							>
								<span class="font-size--13 font-w--300">
									{{ $t("contract.instalments_noteBook") }}
								</span>
							</router-link>
							<!-- </template> -->
							<!-- + '/instalments/'+ this.$route.params.contract_id, -->
							<router-link
								:to="'/customer/payments/' + this.id"
								class="btn btn-bg--dark btn-size--sm btn-hover--3d col-md-5 col-sm-10"
								@click.prevent="updateUser"
								replace
							>
								<span class="font-size--13 font-w--300">
									{{ $t("contract.payment_noteBook") }}
								</span>
							</router-link>
						</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import HeaderSuplier from "../components/shared/HeaderSuplier";
import VueNumeric from "vue-numeric";
export default {
  props: ["id"],
  data() {
    return {
      sign_date: "",
      invoice_date: "",
      description: "",
      net_amount: "",
      number_of_instalment: "",
      downpayment: "",
      status: "",
      supplier_name: "",
      contract_id: "",
      vcc_number: "",
      customer: "",
      supplier: "",
      vcc: "",
      customer_fullname: "",
      clearing_date: "",
      instalment_amount: "",
      total_amount_of_instalments: "",
      instalment_start_date: "",
      end_date: "",
      remaining_amount: "",
      debit_amount: "",
      number_of_pays: "",
      instalment_detail: "",

      columns: [
        {
          label: "تاریخ پرداخت",
          field: "date",
          tdClass: "text-center",
          thClass: "text-center",
        },
        {
          label: "مقدار پرداختی",
          field: "amount",
          tdClass: "text-center",
          thClass: "text-center",
        },
        {
          label: "ما به التفاوت",
          field: "difference",
          tdClass: "text-center",
          thClass: "text-center",
        },
        {
          label: "وضعیت",
          field: "status",
          tdClass: "text-center",
          thClass: "text-center",
        },
      ],
      rows: "",
    };
  },
  mounted() {
    this.showContractDetail();
  },
  computed: {},
  methods: {
    statusFn: function(st) {
      if (st === "0") {
        return '<span class="badge badge-warning" style="height:25px;text-align:center"><b>پرداخت با تاخیر</b></span>';
      }
      if (st === "1") {
        return '<span class="badge badge-success" style="height:25px;"><b>پرداخت به موقع</b></span>';
      }
      if (st === "2") {
        return '<span class="badge badge-danger" style="height:25px;"><b> پرداخت نشده</b></span>';
      }
      if (st === "3") {
        return '<span class="badge badge-secondary" style="height:25px;text-align:center"><b>موعد قسط نرسیده است</b></span>';
      }

      return;
    },
    actionBtn: function() {
      return '<button  @click.prevent="showContractDetail" type="button" class="btn btn-primary text-center font-w--400 " style="width:70px;height:35px;font-size: 0.75rem;">جزییات</button>';
    },
    rowStyleClassFn(row) {
      if (row.status === "0") {
          return 'bg-warning'
      }
      if (row.status === "1") {
        return 'bg-success';
      }
      if (row.status === "2") {
        return 'bg-danger';
      }
      if (row.status === "3") {
        return 'bg-light';
      }
     
    },
    // eslint-disable-next-line no-unused-vars
    statusShow(st) {
      if (st === "0") {
        return '<span class="badge badge-danger" style="height:25px;text-align:center"><b>تایید دریافت پیش پرداخت</b></span>';
      }
      if (st === "1") {
        return '<span class="badge badge-info" style="height:25px;"><b>در حال عقد قراداد</b></span>';
      }
      if (st === "2") {
        return '<span class="badge badge-success" style="height:25px;"><b> تایید قرارداد و ارسال کالا</b></span>';
      }
      if (st === "3") {
        return '<span class="badge badge-info" style="height:25px;text-align:center"><b>تسویه با فروشگاه</b></span>';
      }
      if (st === "4") {
        return '<span class="badge badge-info" style="height:25px;"><b>پرداخت اقساط توسط متقاضی</b></span>';
      }
      if (st === "5") {
        return '<span class="badge badge-success" style="height:25px;"><b> تسویه متقاضی و تحویل مدارک</b></span>';
      }
      if (st === "6") {
        return '<span class="badge badge-warning" style="height:25px;"><b>نکول قطعی</b></span>';
      }
      if (st === "7") {
        return '<span class="badge badge-danger" style="height:25px;"><b>انصراف متقاضی</b></span>';
      }
    },
    showContractDetail() {
      let load=this.$loading.show()
      console.log("props= ", this.id);
      this.$store
        .dispatch("getContractDetail", this.id)
        .then((resp) => {
          (this.sign_date = resp.body.sign_date),
            (this.invoice_date = resp.body.invoice_date),
            (this.description = resp.body.description),
            (this.net_amount = resp.body.net_amount),
            (this.number_of_instalment = resp.body.number_of_instalment),
            (this.downpayment = resp.body.downpayment),
            (this.status = resp.body.status),
            (this.supplier_name = resp.body.supplier_name),
            (this.contract_id = resp.body.contract_id),
            (this.vcc_number = resp.body.vcc_number),
            (this.customer = resp.body.customer),
            (this.customer_fullname = resp.body.customer_fullname),
            (this.clearing_date = resp.body.clearing_date),
            (this.instalment_amount = resp.body.instalment_amount),
            (this.total_amount_of_instalments =
              resp.body.total_amount_of_instalments),
            (this.instalment_start_date = resp.body.instalment_start_date),
            (this.end_date = resp.body.end_date),
            (this.remaining_amount = resp.body.remaining_amount),
            (this.debit_amount = resp.body.debit_amount),
            (this.number_of_pays = resp.body.number_of_pays),
            (this.instalment_detail = resp.body.instalment_detail);
          this.rows = resp.body.instalment_detail;
          load.hide()
        })
        .catch((err) => {
          console.log(err);
          load.hide()
        });
    },
  },
  components: {
    VueNumeric,
  },
};
</script>

<style>
.green {
  background-color: green;
}

.red {
  background-color: red;
}
</style>
